import {
  AUSTRALIA_NEWZEALAND_PAGE,
  WORKDAY_EN_PATH,
} from "../../../../interfaces/Static/routing_paths";
import { AUSTRALIA_NEWZEALAND_PROGRAM } from "./_programs";
import financial_services from "../../../../assets/images/oceania/financial_services.webp";
import financial_services_banner from "../../../../assets/images/oceania/financial_services_banner.webp";
const ANZ_LOCATIONS = {
  id: 1,
  name: "Australia & New Zealand",
  slug: "melbourne-victoria-nma",
  items: AUSTRALIA_NEWZEALAND_PROGRAM.filter(
    (x) => ["melbourne-victoria"].indexOf(x.slug) >= 0
  ),
};
export const FINANCIAL_SERVICES = {
  id: "financial-services",
  card_src: financial_services,
  card_title: "page.oceania.financial_services",
  card_description: "page.oceania.financial_services_description",
  banner_src: financial_services_banner,
  banner_title: "page.oceania.financial_services",
  banner_description: "Your Finance Career Awaits",
  slug: "financial-services",
  href: `${AUSTRALIA_NEWZEALAND_PAGE}/financial-services`,
  name: "page.oceania.financial_services",
  description:
    "At Nissan Financial Services, we fuel the success of both our customers and our Dealer network, delivering tailored finance solutions that support every stage of the vehicle journey. <br /><br /> From customer service and compliance, to risk management, finance operations, and sales, our teams play a vital role in driving customer satisfaction and business growth. No matter where you start, you’ll find a path to develop your skills and advance your career. Working closely with our broader Motor business, you’ll gain unique insight into the automotive industry, and benefit from a strong, collaborative partnership that creates a competitive edge in the market. <br /><br /> As our business evolves, so do your opportunities. Whether you want to deepen your expertise or take on new challenges, Nissan Financial Services is where you can grow with confidence, surrounded by a team that backs your ambition.",
  categories: [
    {
      id: 1,
      name: "Who we are",
      slug: "who_we_are",
      description:
        "At Nissan Financial Services, we are more than just a financial services company; we are a team dedicated to crafting personalised financial solutions for our customers and dealer partners in Australia and New Zealand. <br /> <br />When you join us, you will discover a world of possibilities within our dynamic organisation of over 200 employees. From engaging with customers directly in Customer Service to assessing credit risks in Retail and Commercial Credit, ensuring regulatory compliance, streamlining processes in Operations, or driving sales, your career path can lead you in exciting directions.<br /> <br /> We are a vital force behind Nissan's success, providing a competitive edge and a strong partnership with the Motor business. As both businesses grow, your opportunities for professional development and advancement grow too.",
      locations: [ANZ_LOCATIONS],
    },
    {
      id: 2,
      name: "Where you can start",
      slug: "where_you_can",
      description:
        "At Nissan Financial Services, your career has multiple lanes to get moving. Whether you thrive on being in the driver’s seat with our customers or prefer working under the hood to keep everything running smoothly, there’s a perfect starting line for you. <br /><br /> If building relationships and delivering exceptional service excites you, our customer-facing roles put you in the fast lane to make a real impact on people’s journeys. <br /><br />If you’re more driven by numbers, analysis, and problem-solving, our operational and analytical roles give you the chance to fine-tune your skills and jump-start your career with hands-on experience.",
      locations: [ANZ_LOCATIONS],
    },
    {
      id: 3,
      name: "Specialist Areas",
      slug: "specialist_areas",
      description:
        "Being an integrated automotive financier means, we offer diverse roles that demand specialised expertise.<br /> <br /> If you're a relationship-builder with a passion for fleet sales, you could join our Fleet Sales Team, where you'll play a vital role in fostering strong connections between fleet clients, dealers, and our team.<br /> <br /> Alternatively, if you have a background in finance and a knack for customer service, you could bring your experience to our Sales or Credit Teams.",
      locations: [ANZ_LOCATIONS],
    },
    {
      id: 4,
      name: "Career Pathways",
      slug: "career_pathways",
      description:
        "No matter where you begin your journey at Nissan Financial Services in Australia and New Zealand, your role will open doors to exciting pathways across our organisation.<br /> <br /> You could discover opportunities within other areas of Financial Services, move to the Motor business, or even explore possibilities within our Global Financial Services function.",
      locations: [ANZ_LOCATIONS],
    },
  ],
  work_day_link: `https://www.livehire.com/careers/nissan/jobs`,
};
